/*!
 * ====================================================================
 *  MNR – GTM Event Engine  v1.0
 *  Store: Mannarinu (www.mannarinu.com)  |  Container: GTM-N3VDC7ZD
 *  Built by Aces Ads. Loaded from snippets/mnr-datalayer.liquid.
 *
 *  Emits a vendor-neutral, GA4-schema dataLayer. Which events get
 *  forwarded to GA4 / Google Ads / Meta is decided in GTM, so this
 *  file never needs to change when tag strategy changes.
 * ====================================================================
 */
(function () {
  'use strict';

  var CFG = window.MNR_CONFIG || {};
  var DL  = (window.dataLayer = window.dataLayer || []);
  var CUR = CFG.currency || 'EUR';
  var COUNTRY = CFG.country || 'MT';

  function log() { if (CFG.debug && window.console) { console.log.apply(console, ['[MNR]'].concat([].slice.call(arguments))); } }

  function uid() {
    return 'mnr-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
  }

  function push(event, payload) {
    var data = payload || {};
    if (data.ecommerce) { DL.push({ ecommerce: null }); }
    data.event = event;
    data.mnr_source = data.mnr_source || 'theme';
    data.mnr_event_id = data.mnr_event_id || uid();
    DL.push(data);
    log(event, data);
  }
  window.mnrPush = push;

  function money(cents) { return Math.round((Number(cents) || 0)) / 100; }
  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches && el.matches(sel)) { return el; } el = el.parentElement; }
    return null;
  }
  function ready(fn) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); } else { fn(); }
  }

  /* =================================================================
     CART STATE + DIFFING
     Every cart mutation (theme, drawer, quick-add, app, upsell) is
     detected by diffing a cached /cart.js snapshot, so this works
     regardless of which app or theme code performed the change.
  ================================================================= */
  var cartSnapshot = { items: {}, count: 0, total: 0 };
  var cartReady = false;

  function lineToItem(line, index) {
    return {
      item_id: String(line.variant_id),
      item_name: line.product_title || line.title,
      item_brand: line.vendor || '',
      item_category: line.product_type || '',
      item_variant: line.variant_title || '',
      item_sku: line.sku || '',
      product_id: String(line.product_id),
      google_id: 'shopify_' + COUNTRY + '_' + line.product_id + '_' + line.variant_id,
      price: money(line.final_price != null ? line.final_price : line.price),
      quantity: line.quantity,
      index: (index || 0) + 1
    };
  }

  function snapshotFrom(cart) {
    var map = {};
    (cart.items || []).forEach(function (l, i) { map[l.variant_id] = { line: l, item: lineToItem(l, i) }; });
    return { items: map, count: cart.item_count, total: money(cart.total_price) };
  }

  function fetchCart() {
    return fetch(CFG.routes && CFG.routes.cart ? CFG.routes.cart + '.js' : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function initCart() {
    fetchCart().then(function (cart) {
      if (cart) { cartSnapshot = snapshotFrom(cart); }
      cartReady = true;
    });
  }

  function reconcileCart(hint) {
    if (!cartReady) { return; }
    fetchCart().then(function (cart) {
      if (!cart) { return; }
      var next = snapshotFrom(cart);
      var added = [], removed = [];

      Object.keys(next.items).forEach(function (vid) {
        var before = cartSnapshot.items[vid];
        var afterQ = next.items[vid].line.quantity;
        var beforeQ = before ? before.line.quantity : 0;
        if (afterQ > beforeQ) {
          var it = Object.assign({}, next.items[vid].item, { quantity: afterQ - beforeQ });
          added.push(it);
        } else if (afterQ < beforeQ) {
          var itr = Object.assign({}, next.items[vid].item, { quantity: beforeQ - afterQ });
          removed.push(itr);
        }
      });
      Object.keys(cartSnapshot.items).forEach(function (vid) {
        if (!next.items[vid]) {
          removed.push(Object.assign({}, cartSnapshot.items[vid].item));
        }
      });

      if (added.length) {
        push('add_to_cart', {
          mnr_trigger: hint || 'cart_api',
          ecommerce: { currency: CUR, value: sumValue(added), items: added }
        });
      }
      if (removed.length) {
        push('remove_from_cart', {
          mnr_trigger: hint || 'cart_api',
          ecommerce: { currency: CUR, value: sumValue(removed), items: removed }
        });
      }
      if (added.length || removed.length) {
        push('mnr_cart_updated', { cart: { value: next.total, items: next.count, currency: CUR } });
      }
      cartSnapshot = next;
    });
  }

  function sumValue(items) {
    return Math.round(items.reduce(function (s, i) { return s + (i.price * (i.quantity || 1)); }, 0) * 100) / 100;
  }

  /* ---- intercept fetch + XHR against cart endpoints ---- */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;

  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var href = typeof url === 'string' ? url : (url && url.url) || '';
      var p = _fetch.apply(this, arguments);
      if (CART_RE.test(href)) {
        p.then(function () { setTimeout(function () { reconcileCart(href.indexOf('add') > -1 ? 'ajax_add' : 'ajax_change'); }, 120); }).catch(function () {});
      }
      return p;
    };
  }

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__mnrUrl = url;
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (CART_RE.test(xhr.__mnrUrl || '')) {
      xhr.addEventListener('load', function () {
        setTimeout(function () { reconcileCart(String(xhr.__mnrUrl).indexOf('add') > -1 ? 'xhr_add' : 'xhr_change'); }, 120);
      });
    }
    return _send.apply(this, arguments);
  };

  /* ---- non-ajax add-to-cart form submits (full page reload) ---- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) {
      try { sessionStorage.setItem('mnr_pending_atc', '1'); } catch (err) {}
    }
  }, true);

  /* =================================================================
     PRODUCT LIST INTERACTIONS
  ================================================================= */
  function itemFromCard(card) {
    if (!card) { return null; }
    var link = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    var handle = (href.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) { return null; }
    var titleEl = card.querySelector('[class*="title"], h2, h3, .card__heading');
    var priceEl = card.querySelector('[class*="price"] .money, [class*="price-item"], [class*="price"]');
    var price = priceEl ? parseFloat((priceEl.textContent || '').replace(/[^0-9.,]/g, '').replace(',', '.')) : null;
    return {
      item_id: card.getAttribute('data-variant-id') || handle,
      item_name: (titleEl ? titleEl.textContent : (link ? link.textContent : '')).trim().slice(0, 120),
      item_handle: handle,
      price: isNaN(price) ? null : price,
      quantity: 1
    };
  }

  document.addEventListener('click', function (e) {
    var link = closest(e.target, 'a[href*="/products/"]');
    if (!link) { return; }
    var card = closest(link, '[data-product-id], li, .card, .grid__item, .product-card, .pf-c') || link;
    var item = itemFromCard(card);
    if (!item) { return; }
    var listWrap = closest(card, '[data-list-name], .collection, .product-grid, .related-products, .pf-main-wrapper');
    push('select_item', {
      ecommerce: {
        currency: CUR,
        item_list_id: (listWrap && listWrap.getAttribute('data-list-id')) || (CFG.__listId || 'grid'),
        item_list_name: (listWrap && listWrap.getAttribute('data-list-name')) || (CFG.__listName || document.title),
        items: [item]
      }
    });
  }, true);

  /* ---- view_item_list for grids not rendered by the head snippet
         (recommendations, PageFly product blocks, upsells) ---- */
  ready(function () {
    if (!('IntersectionObserver' in window)) { return; }
    var grids = document.querySelectorAll('.related-products, [data-mnr-list], .product-recommendations');
    if (!grids.length) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || en.target.__mnrSeen) { return; }
        en.target.__mnrSeen = true;
        var cards = en.target.querySelectorAll('a[href*="/products/"]');
        var seen = {}, items = [];
        [].forEach.call(cards, function (c) {
          var it = itemFromCard(closest(c, 'li, .card, .grid__item') || c);
          if (it && !seen[it.item_handle]) { seen[it.item_handle] = 1; it.index = items.length + 1; items.push(it); }
        });
        if (items.length) {
          push('view_item_list', {
            ecommerce: {
              currency: CUR,
              item_list_id: en.target.getAttribute('data-mnr-list') || 'recommendations',
              item_list_name: en.target.getAttribute('data-mnr-list-name') || 'Recommended products',
              items: items.slice(0, 20)
            }
          });
        }
        io.unobserve(en.target);
      });
    }, { threshold: 0.4 });
    [].forEach.call(grids, function (g) { io.observe(g); });
  });

  /* =================================================================
     CART DRAWER / MINI-CART OPEN  -> view_cart
  ================================================================= */
  var lastViewCart = 0;
  document.addEventListener('click', function (e) {
    var t = closest(e.target, '[href$="/cart"], [data-cart-drawer-toggle], .cart-icon, #cart-icon-bubble, [aria-controls*="Cart"], [class*="cart-toggle"]');
    if (!t) { return; }
    if (Date.now() - lastViewCart < 1500) { return; }
    lastViewCart = Date.now();
    fetchCart().then(function (cart) {
      if (!cart || !cart.item_count) { return; }
      push('view_cart', {
        mnr_trigger: 'drawer',
        ecommerce: {
          currency: CUR,
          value: money(cart.total_price),
          items: (cart.items || []).map(lineToItem)
        }
      });
    });
  }, true);

  /* ---- begin_checkout on checkout button click (pre-redirect) ---- */
  document.addEventListener('click', function (e) {
    var b = closest(e.target, '[name="checkout"], [href*="/checkout"], .cart__checkout-button, [data-mnr-checkout]');
    if (!b) { return; }
    fetchCart().then(function (cart) {
      if (!cart) { return; }
      push('mnr_checkout_click', {
        ecommerce: {
          currency: CUR,
          value: money(cart.total_price),
          items: (cart.items || []).map(lineToItem)
        }
      });
    });
  }, true);

  /* =================================================================
     WISHLIST (Growave) / QUICK VIEW
  ================================================================= */
  document.addEventListener('click', function (e) {
    var w = closest(e.target, '[class*="wishlist"], [data-wishlist], .gw-wishlist-button, [aria-label*="wishlist" i]');
    if (!w) { return; }
    var card = closest(w, 'li, .card, .grid__item, .product, form') || document;
    var item = itemFromCard(card);
    push('add_to_wishlist', {
      ecommerce: { currency: CUR, items: item ? [item] : [] }
    });
  }, true);

  /* =================================================================
     LEAD / CONTACT / NEWSLETTER
  ================================================================= */
  var startedForms = new WeakSet ? new WeakSet() : { add: function () {}, has: function () { return false; } };

  function formKind(form) {
    var action = (form.getAttribute('action') || '').toLowerCase();
    var ft = form.querySelector('input[name="form_type"]');
    var type = ft ? ft.value : '';
    if (type === 'customer' || /newsletter/i.test(form.className) || form.querySelector('[name="contact[accepts_marketing]"]')) { return 'newsletter'; }
    if (type === 'create_customer') { return 'sign_up'; }
    if (type === 'customer_login') { return 'login'; }
    if (type === 'contact' || /\/contact/.test(action)) { return 'lead'; }
    if (closest(form, 'shopify-form') || form.hasAttribute('data-mnr-lead')) { return 'lead'; }
    if (/\/search/.test(action)) { return 'search'; }
    return null;
  }

  document.addEventListener('focusin', function (e) {
    var form = closest(e.target, 'form');
    if (!form || startedForms.has(form)) { return; }
    var kind = formKind(form);
    if (!kind || kind === 'search') { return; }
    startedForms.add(form);
    push('form_start', { form_kind: kind, form_id: form.id || '', form_location: location.pathname });
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') { return; }
    var kind = formKind(form);
    if (!kind) { return; }

    if (kind === 'search') {
      var q = form.querySelector('[name="q"]');
      if (q && q.value) { push('search', { search_term: q.value, mnr_trigger: 'form' }); }
      return;
    }

    var fields = {};
    ['contact[Name]', 'contact[name]', 'contact[email]', 'contact[Phone Number]', 'contact[phone]', 'contact[Message]', 'email', 'phone']
      .forEach(function (n) { var el = form.querySelector('[name="' + n + '"]'); if (el && el.value) { fields[n] = el.value; } });

    var email = fields['contact[email]'] || fields.email || '';
    var phone = fields['contact[Phone Number]'] || fields['contact[phone]'] || fields.phone || '';

    var payload = {
      form_kind: kind,
      form_id: form.id || '',
      form_location: location.pathname,
      form_page_title: document.title,
      lead_type: /wedding/i.test(location.pathname) ? 'wedding'
               : /catering/i.test(location.pathname) ? 'outside_catering'
               : /brunch/i.test(location.pathname) ? 'brunch_bar'
               : 'general',
      /* raw values stay client-side only: GTM hashes them for
         Enhanced Conversions and never writes them to GA4 */
      user_data: { email: email || undefined, phone_number: normalisePhone(phone) || undefined }
    };

    if (kind === 'newsletter') { push('newsletter_signup', payload); }
    else if (kind === 'sign_up') { push('sign_up', payload); }
    else if (kind === 'login') { push('login', payload); }
    else { push('generate_lead', payload); }
  }, true);

  function normalisePhone(p) {
    if (!p) { return ''; }
    var d = String(p).replace(/[^0-9+]/g, '');
    if (d && d.charAt(0) !== '+') {
      if (d.length === 8) { d = '+356' + d; }        /* Malta mobile/landline */
      else if (d.indexOf('00') === 0) { d = '+' + d.slice(2); }
    }
    return d;
  }

  /* ---- Shopify contact-form success redirect (?contact_posted=true) ---- */
  ready(function () {
    if (/contact_posted=true/.test(location.search)) {
      push('generate_lead_confirmed', { form_kind: 'lead', form_location: location.pathname });
    }
    if (/\/pages\/thank-you/.test(location.pathname)) {
      push('mnr_thank_you_page', { page_path: location.pathname });
    }
    try {
      if (sessionStorage.getItem('mnr_pending_atc')) {
        sessionStorage.removeItem('mnr_pending_atc');
        push('mnr_atc_page_reload', {});
      }
    } catch (err) {}
  });

  /* =================================================================
     CONTACT INTENT CLICKS
  ================================================================= */
  document.addEventListener('click', function (e) {
    var a = closest(e.target, 'a[href]');
    if (!a) { return; }
    var href = a.getAttribute('href') || '';

    if (/^tel:/i.test(href)) {
      return push('click_phone', { contact_method: 'phone', link_url: href, link_text: (a.textContent || '').trim().slice(0, 80), page_path: location.pathname });
    }
    if (/wa\.me|api\.whatsapp\.com|whatsapp:/i.test(href)) {
      return push('click_whatsapp', { contact_method: 'whatsapp', link_url: href, link_text: (a.textContent || '').trim().slice(0, 80), page_path: location.pathname });
    }
    if (/^mailto:/i.test(href)) {
      return push('click_email', { contact_method: 'email', link_url: href, page_path: location.pathname });
    }
    if (/\.(pdf|docx?|xlsx?|csv|zip)(\?|$)/i.test(href)) {
      return push('file_download', {
        file_name: (href.split('/').pop() || '').split('?')[0],
        file_extension: (href.split('.').pop() || '').split('?')[0].toLowerCase(),
        link_url: href,
        is_menu: /menu|catering|wedding|brochure/i.test(href) ? true : false
      });
    }
    if (/^https?:/i.test(href) && href.indexOf(location.hostname) === -1) {
      var host = '';
      try { host = new URL(href).hostname; } catch (err) {}
      var social = /facebook|instagram|tiktok|youtube|linkedin|pinterest/i.test(host);
      return push(social ? 'social_click' : 'outbound_click', { link_url: href, link_domain: host, link_text: (a.textContent || '').trim().slice(0, 80) });
    }
    if (a.hasAttribute('data-mnr-cta')) {
      return push('cta_click', { cta_id: a.getAttribute('data-mnr-cta'), cta_text: (a.textContent || '').trim().slice(0, 80), page_path: location.pathname });
    }
  }, true);

  document.addEventListener('click', function (e) {
    var b = closest(e.target, 'button[data-mnr-cta], [role="button"][data-mnr-cta]');
    if (b) { push('cta_click', { cta_id: b.getAttribute('data-mnr-cta'), cta_text: (b.textContent || '').trim().slice(0, 80), page_path: location.pathname }); }
  }, true);

  /* =================================================================
     ENGAGEMENT: SCROLL DEPTH + TIME ON PAGE
  ================================================================= */
  ready(function () {
    var thresholds = (CFG.scrollThresholds || [25, 50, 75, 90]).slice().sort(function (a, b) { return a - b; });
    var hit = {};
    function onScroll() {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight);
      if (max <= 0) { return; }
      var pct = Math.round((h.scrollTop || document.body.scrollTop) / max * 100);
      thresholds.forEach(function (t) {
        if (pct >= t && !hit[t]) {
          hit[t] = true;
          push('scroll_depth', { percent_scrolled: t, page_path: location.pathname, page_type: (CFG.__pageType || '') });
        }
      });
    }
    window.addEventListener('scroll', throttle(onScroll, 400), { passive: true });
    onScroll();

    (CFG.engagedSeconds || [15, 30, 60, 120]).forEach(function (s) {
      setTimeout(function () {
        if (!document.hidden) { push('engaged_time', { engagement_seconds: s, page_path: location.pathname }); }
      }, s * 1000);
    });
  });

  function throttle(fn, wait) {
    var last = 0, timer;
    return function () {
      var now = Date.now();
      if (now - last >= wait) { last = now; fn(); }
      else { clearTimeout(timer); timer = setTimeout(function () { last = Date.now(); fn(); }, wait); }
    };
  }

  /* =================================================================
     VIDEO
  ================================================================= */
  ready(function () {
    [].forEach.call(document.querySelectorAll('video'), function (v) {
      var marks = {};
      v.addEventListener('play', function () {
        if (!v.__mnrStarted) { v.__mnrStarted = true; push('video_start', videoMeta(v)); }
      });
      v.addEventListener('timeupdate', function () {
        if (!v.duration) { return; }
        var pct = Math.floor(v.currentTime / v.duration * 100);
        [25, 50, 75].forEach(function (p) {
          if (pct >= p && !marks[p]) { marks[p] = 1; push('video_progress', Object.assign(videoMeta(v), { video_percent: p })); }
        });
      });
      v.addEventListener('ended', function () { push('video_complete', videoMeta(v)); });
    });

    var ytFrames = document.querySelectorAll('iframe[src*="youtube.com/embed"], iframe[src*="youtube-nocookie.com/embed"]');
    if (ytFrames.length) { loadYT(ytFrames); }
  });

  function videoMeta(v) {
    return {
      video_provider: 'html5',
      video_title: v.getAttribute('title') || v.getAttribute('data-title') || (v.currentSrc || '').split('/').pop() || 'video',
      video_url: v.currentSrc || '',
      video_duration: Math.round(v.duration || 0)
    };
  }

  function loadYT(frames) {
    [].forEach.call(frames, function (f) {
      if (f.src.indexOf('enablejsapi') === -1) {
        f.src = f.src + (f.src.indexOf('?') > -1 ? '&' : '?') + 'enablejsapi=1';
      }
    });
    if (window.YT && window.YT.Player) { return bindYT(frames); }
    var s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(s);
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') { prev(); }
      bindYT(frames);
    };
  }

  function bindYT(frames) {
    [].forEach.call(frames, function (f) {
      try {
        var marks = {};
        new window.YT.Player(f, {
          events: {
            onStateChange: function (e) {
              var p = e.target;
              var meta = { video_provider: 'youtube', video_title: (p.getVideoData && p.getVideoData().title) || '', video_url: p.getVideoUrl ? p.getVideoUrl() : '', video_duration: Math.round(p.getDuration() || 0) };
              if (e.data === window.YT.PlayerState.PLAYING && !f.__mnrStarted) { f.__mnrStarted = true; push('video_start', meta); }
              if (e.data === window.YT.PlayerState.ENDED) { push('video_complete', meta); }
              if (e.data === window.YT.PlayerState.PLAYING) {
                clearInterval(f.__mnrInt);
                f.__mnrInt = setInterval(function () {
                  var pct = Math.floor(p.getCurrentTime() / p.getDuration() * 100);
                  [25, 50, 75].forEach(function (m) { if (pct >= m && !marks[m]) { marks[m] = 1; push('video_progress', Object.assign({}, meta, { video_percent: m })); } });
                }, 1000);
              } else { clearInterval(f.__mnrInt); }
            }
          }
        });
      } catch (err) {}
    });
  }

  /* =================================================================
     PREDICTIVE SEARCH TERMS (typed, debounced)
  ================================================================= */
  ready(function () {
    var inputs = document.querySelectorAll('input[name="q"]');
    [].forEach.call(inputs, function (i) {
      var t;
      i.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          if (i.value && i.value.length > 2) { push('mnr_search_typed', { search_term: i.value }); }
        }, 1200);
      });
    });
  });

  /* =================================================================
     ZAPIET DELIVERY / PICKUP METHOD (catering-relevant dimension)
  ================================================================= */
  ready(function () {
    setTimeout(function () {
      try {
        var m = (window.ZapietWidget && window.ZapietWidget.method) ||
                localStorage.getItem('ZapietMethod') ||
                (document.querySelector('[name="attributes[Checkout-Method]"]') || {}).value;
        if (m) { push('mnr_fulfilment_method', { fulfilment_method: String(m).toLowerCase() }); }
      } catch (err) {}
    }, 2500);
  });

  /* =================================================================
     BOOT
  ================================================================= */
  initCart();
  push('mnr_engine_ready', { engine_version: CFG.version || '1.0' });
})();
